function clone(data) {
  return JSON.parse(JSON.stringify(data));
}
const isBoolean = (value) => {
  return value === true || value === false;
};
const rowHeaderTooltipId = (tableId) => {
  return `row-header-tooltip:${tableId}`;
};
const columnHeaderTooltipId = (tableId) => {
  return `column-header-tooltip:${tableId}`;
};
const columnHeaderClickableTooltipId = (tableId) => {
  return `column-header-clickable-tooltip:${tableId}`;
};
export {
  clone,
  columnHeaderClickableTooltipId,
  columnHeaderTooltipId,
  isBoolean,
  rowHeaderTooltipId
};
